// extracted by mini-css-extract-plugin
export default {"head":"List_head__N7IIN","headMain":"List_headMain__nxdr-","pad0":"List_pad0__RG44z","id":"List_id__19kR8","btntbl":"List_btntbl__Sxhh7","btns":"List_btns__ridOF"};